import { render, staticRenderFns } from "./EnrolmentOrganisationListPopup.vue?vue&type=template&id=1142a5d6&scoped=true&"
import script from "./EnrolmentOrganisationListPopup.vue?vue&type=script&lang=js&"
export * from "./EnrolmentOrganisationListPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1142a5d6",
  null
  
)

export default component.exports